// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EyeLine from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import Button from "@store/MobiusOverrides/Button/Button";
import { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Props";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductVisualizerButtonPresentationProps extends ExpandStyles<ProductVisualizerButtonStyles> {}

export interface ProductVisualizerButtonProps extends ProductVisualizerButtonPresentationProps {
    productNumber: string | undefined | null;
}

export interface ProductVisualizerButtonStyles {
    wrapper?: InjectableCss;
    button?: ButtonPresentationProps;
}

const productVisualizerButtonStyles: ProductVisualizerButtonStyles = {
    button: {
        variant: "tertiary",
        sizeVariant: "small",
        icon: {
            position: "left",
            src: EyeLine,
        },
        mergeCss: true,
        css: css`
            display: none;
            visibility: hidden; /* Required by Roomvo */

            &&[data-active="true"] {
                display: block;
            }
        `,
    },
};

const ProductVisualizerButton: FC<ProductVisualizerButtonProps> = ({
    extendedStyles,
    overridedStyles,
    productNumber,
}) => {
    const styles = useExpandProps(productVisualizerButtonStyles, extendedStyles, overridedStyles);
    const enableVisualizer = useSettingsCollection().customSettings?.enableVisualizer;

    if (!enableVisualizer || !productNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} className="roomvo-container">
            <Button {...styles.button} className="roomvo-stimr" data-sku={productNumber}>
                {translate("Visualize in your room")}
            </Button>
        </StyledWrapper>
    );
};

export default ProductVisualizerButton;
